import * as z from 'zod'
import validator from 'validator'

export const FormFieldResolvers = {
  phone: z.string().refine(validator.isMobilePhone, { message: 'Nieprawidłowy numer telefonu' }),
}
